import { StyleSheet } from "react-native"

export default StyleSheet.create({
  suggestionMessageContainer: {
    //transform: [{ scaleY: -1 }],
    width: "100%",
  },
})
